import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../lib/api';

export default function DashboardPage() {
  const { profile } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const res = await api.get('/credits/balance');
        setStats(res.data);
      } catch {}
    }
    load();
  }, []);

  const tools = [
    { group: 'Domain', items: [
      { to: '/domain/overview', icon: '◧', title: 'Domain Overview', desc: 'Authority, traffic, keywords, backlinks', credits: 3 },
      { to: '/domain/organic', icon: '◫', title: 'Organic Research', desc: 'All organic keywords & positions', credits: 4 },
      { to: '/domain/traffic', icon: '⬔', title: 'Traffic Analytics', desc: 'Visits, sources, geo', credits: 3 },
    ]},
    { group: 'Keyword Research', items: [
      { to: '/keywords/overview', icon: '⌕', title: 'Keyword Overview', desc: 'Volume, KD, CPC, SERP', credits: 3 },
      { to: '/keywords/magic', icon: '✦', title: 'Keyword Magic Tool', desc: '200+ ideas from seed', credits: 5 },
      { to: '/keywords/gap', icon: '⬙', title: 'Keyword Gap', desc: 'Find missing keywords', credits: 5 },
      { to: '/keywords/difficulty', icon: '⚡', title: 'Bulk KD', desc: 'Check 100 keywords at once', credits: 2 },
    ]},
    { group: 'Backlinks', items: [
      { to: '/backlinks/overview', icon: '🔗', title: 'Backlink Analytics', desc: 'Backlinks & ref domains', credits: 4 },
      { to: '/backlinks/gap', icon: '⧉', title: 'Backlink Gap', desc: 'Competitor link opportunities', credits: 5 },
    ]},
    { group: 'Technical SEO', items: [
      { to: '/audit/site', icon: '◍', title: 'Site Audit', desc: '130+ SEO checks', credits: 5 },
      { to: '/audit/onpage', icon: '◎', title: 'On Page Checker', desc: 'Optimize for keyword', credits: 3 },
    ]}
  ];

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Welcome back, {profile?.full_name || 'there'}</h1>
        <p className="page-sub">{profile?.credits?.toLocaleString() || 0} credits available on {profile?.plan || 'pro'} plan • All professional tools ready</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6B7280', marginBottom: 8 }}>Credits</div>
          <div style={{ fontSize: 28, fontWeight: 800 }}>{profile?.credits?.toLocaleString() || 0}</div>
          <div style={{ fontSize: 12, color: '#6B7280' }}>remaining on {profile?.plan} plan</div>
          <div className="progress" style={{ marginTop: 12 }}><div className="progress-fill" style={{ width: '70%', background: '#FF642D' }} /></div>
        </div>
        <div className="stat-card">
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6B7280', marginBottom: 8 }}>Professional Tools</div>
          <div style={{ fontSize: 28, fontWeight: 800 }}>26</div>
          <div style={{ fontSize: 12, color: '#6B7280' }}>SEO and content tools available</div>
          <div style={{ display: 'flex', gap: 4, marginTop: 12 }}>
            {['Domain', 'Keyword', 'Backlink', 'Audit'].map(t => <span key={t} className="badge badge-gray">{t}</span>)}
          </div>
        </div>
        <div className="stat-card" style={{ background: '#111', color: 'white', borderColor: '#111' }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#9CA3AF', marginBottom: 8 }}>Quick Start</div>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Enter domain or keyword above ↑</div>
          <div style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 12 }}>Or pick a tool below to start analyzing</div>
          <Link to="/domain/overview" className="btn btn-sm" style={{ background: '#FF642D', color: 'white', border: 'none' }}>Analyze domain</Link>
        </div>
      </div>

      {tools.map(group => (
        <div key={group.group} style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#6B7280', marginBottom: 12 }}>{group.group}</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
            {group.items.map(tool => (
              <Link key={tool.to} to={tool.to} className="tool-card" style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 36, height: 36, borderRadius: 6, background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 }}>{tool.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
                    {tool.title}
                    <span className="badge badge-orange" style={{ fontSize: 10 }}>{tool.credits} cr</span>
                  </div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{tool.desc}</div>
                </div>
                <span style={{ color: '#D1D5DB' }}>→</span>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
